import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';

const HorizontalCarousel = ({
  current,
  header,
  headerClass,
  onClickPrev,
  onClickNext,
  children,
  numDisplayItems = 4,
  className,
  itemContainerClass,
  itemWrapperClass,
  leftIconClassName,
  rightIconClassName,
  noItemMessage
}) => {
  children = React.Children.toArray(children);
  const items = _.slice(_.drop(children, numDisplayItems * current), 0, numDisplayItems);
  const leftIconClass = classNames({
    [styles.left]: true,
    [leftIconClassName]: leftIconClassName,
    "pointer": !current === 0,
    "text-gray faded": current === 0
  });

  const rightIconClass = classNames({
    [styles.right]: true,
    [rightIconClassName]: rightIconClassName,
    "pointer": !(current >= ((children.length / numDisplayItems) - 1) || (children.length < numDisplayItems)),
    "text-gray faded": current >= ((children.length / numDisplayItems) - 1) || (children.length < numDisplayItems)
  });

  return (
    <div className={`${className || ''} d-flex flex-column`}>
      <div className={`d-flex flex-row ${styles.header} ${headerClass || ''}`}>
        {header}
      </div>
      {
        children.length > 0 ?
          <div className={`${itemContainerClass || ''} d-flex flex-row align-items-center justify-content-between w-100`}>
            <FontAwesomeIcon icon="chevron-left" onClick={onClickPrev} className={leftIconClass} />
            <div className={`${itemWrapperClass || 'row flex-grow-1'}`}>
              {items}
            </div>
            <FontAwesomeIcon icon="chevron-right" onClick={onClickNext} className={rightIconClass} />
          </div> :
          <span>{noItemMessage ? noItemMessage : 'No one here yet!'}</span>
      }
    </div>
  );
};

HorizontalCarousel.propTypes = {
  current: PropTypes.number.isRequired,
  header: PropTypes.string,
  onClickPrev: PropTypes.func.isRequired,
  onClickNext: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  noItemMessage: PropTypes.string
};

export default HorizontalCarousel;
